import { create } from './create';
import { deleteEndpoint } from './delete';
import { invoke } from './invoke';
import { list } from './list';
import { patch } from './patch';

export type { HookInterfaceListQuery } from './list';

export const hookInterfaces = {
  list,
  create,
  delete: deleteEndpoint,
  invoke,
  patch,
};
